<template>
   <div class="cjtoppbox topbox animated fadeIn">

        <!-- //可以抽奖了的引导 -->
        <div class="beginCjBox" v-if="cjState==='1111'">
             <div class="beginboxes">  
                     <img src="../assets/images/game_over.png" class="game_over animated fadeInUp">  
                     <img src="../assets/images/btn_cj.png" class="btn_cj animated zoomIn" @click="beginCjing">      
             </div>   
        </div> 

        <!-- 加载 -->
        <div class="loadingWrap" v-show="cjState==='1112'">
                <div class="loading_box">
                       <!--  <img src="../assets/images/cjloading.gif" > -->
                        <div class="spinner">
                                  <div class="spinner-container container1">
                                    <div class="circle1"></div>
                                    <div class="circle2"></div>
                                    <div class="circle3"></div>
                                    <div class="circle4"></div>
                                  </div>
                                  <div class="spinner-container container2">
                                    <div class="circle1"></div>
                                    <div class="circle2"></div>
                                    <div class="circle3"></div>
                                    <div class="circle4"></div>
                                  </div>
                                  <div class="spinner-container container3">
                                    <div class="circle1"></div>
                                    <div class="circle2"></div>
                                    <div class="circle3"></div>
                                    <div class="circle4"></div>
                                  </div>
                                  <img src="../assets/images/cjloading_ani1.png" class="cjloading_ani1 animated shake infinite">
                        </div>
                        <img src="../assets/images/cjloading_ani2.png" class="cjloading_ani2 pulse animated  infinite">
                </div>
        </div>

        <!-- //未中奖 -->
        <div class="cjFailedBox" v-if="cjState==='1113'">
             <div class="failedboxes">  
                     <img src="../assets/images/cj_failed.png" class="sharebj animated fadeInUp">  
                     <img src="../assets/images/cj_failed_shareBtn.png" class="btn_share animated zoomIn" @click="gotoShare('replay')">  
                     <img src="../assets/images/btn_cj_close.png" class="btn_cj_close  animated fadeIn" @click="gotoBack">      
             </div>   
        </div>    


        <!-- 提交 -->
        <div class="cjSuccessBox" v-if="cjState==='1116'">
             <div class="successboxes">
                 <img :src="luckLists[luckIndex]" class="jpimg animated zoomIn">  
                 <img src="../assets/images/cj_submit_bj.png" class="cj_submit_bj  "> 
                 <div class="submitInside">
                        <p class="jptext animated fadeInUp">请提交正确的联系方式<br/>我们的工作人员会尽快与您联系  </p>
                        <input type="text" name="txt_name" placeholder="姓 名" class=" textfroms animated textname fadeInUp" maxlength="8" v-model="uname" >
                        <input type="text" name="txt_phone" placeholder="电 话" class=" textfroms animated textphone fadeInUp" maxlength="11"  v-model="uphone"  >   
                        <input type="text" name="textaddr" placeholder="地 址" class=" textfroms animated textaddr fadeInUp" maxlength="80"  v-model="uaddr"  > 
                         <img src="../assets/images/cj_submit_btn.png" class="btn_submit animated zoomIn" @click="submitFunc" >  
                 </div>
             </div>
        </div>  

        <!-- //分享引导 -->
        <div class="shareTipsBox" v-if="cjState==='1117'" @click="gotoBack">
             <img src="../assets/images/sharetips.png" class="sharetips animated flash infinite">  
        </div>  

        <!-- //提交成功后 -->
        <div class="submitSuccessBox" v-if="cjState==='1119'">
             <div class="submitOkBoxes">  
                     <img src="../assets/images/cj_submit_ok_bj.png" class="sharebj animated fadeInUp">  
                     <img src="../assets/images/cj_failed_shareBtn.png" class="btn_share animated zoomIn" @click="gotoShare">  
                     <img src="../assets/images/btn_cj_close.png" class="btn_cj_close  animated fadeIn" @click="gotoBack">      
             </div>   
        </div>  

   </div>
</template>


<script type="text/javascript">
import axios from 'axios';

  export default{
    name:'gamecjBox',
    props:[],
    data(){
      return {
        luckIndex:0,
        submitId:0,
        luckLists:[require('../assets/images/cj_jpno0.png'),require('../assets/images/cj_jpno1.png'),require('../assets/images/cj_jpno2.png'),require('../assets/images/cj_jpno3.png'),require('../assets/images/cj_jpno4.png'),require('../assets/images/cj_jpno5.png')],
        uname:'',
        uphone:'',
        uaddr:'',
        submitState:0,
        cjState:'1111'
      }
    },

    mounted (){
       
    },
    methods:{
       resets(){
        //console.log("重置状态");
        this.cjState="1111";
       },
       beginCjing(){
        this.cjState="1112";
        //将状态设置为已抽奖
        vrComponents.fukuangData.luckState=true;
        let that=this;
        setTimeout(function(){
            that.makeLucky();
        },2000);
       },
       makeLucky(){
            if(vrComponents.fukuangData.gameSocre<10){
                //console.log("未完成游戏");
                this.cjState="1113";
                return false;
            }
            if(this.submitState===1){
                //console.log("已中过奖，即已提交过的");
                this.cjState="1113";
                return false;
            }
            let that=this;
            let udataStr=localStorage.getItem("udata");
            if(udataStr==null){
                //console.log("无授权用户信息");
                this.cjState="1113";
                return false;
            }
            let udata=JSON.parse(udataStr);
            let uid="";
            if(vrComponents.isWxapp==0){
                //微博
                uid=udata.uid;
            }else{
                //微信
                uid=udata.openid;
            }

            let apptype='wx';
            if(vrComponents.isWxapp=='0'){
                 apptype='wb';
            }

            let param = new URLSearchParams();
            param.append('uParameter', 'getJPlist');
            param.append('uid', uid);
            param.append('apptype', apptype);
            param.append('udata', udataStr);

            //直接返回未中奖
            that.cjState="1113";
            vrComponents.fukuangData.needReplay=true;
            /*axios({
                url: 'http://www.vweb365.com/h5/case/20200521dengkang_v7/',
                method: 'POST',
                responseType: 'json', // 默认的
                 headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                  },
                data: param
            }).then(function (response) {

                let resData=response.data;
                if(resData.getJP_msg==='1'){
                    //中奖
                    that.cjState="1116";
                    //更新奖项
                    that.luckIndex=resData.getJP_id;
                    that.submitId=resData.jp_Id;
                    
                }else{
                    that.cjState="1113";
                    vrComponents.fukuangData.needReplay=true;
                    return false;
                }
            }).catch(function (error) {
                console.log(error);
                    that.cjState="1113";
                    vrComponents.fukuangData.needReplay=true;
                    return false;
            });*/
       },
       gotoShare(isreplay){
        //分享
        if(vrComponents.isWxapp=='0'){
            //分享微博
            this.shareWb();
        }else{
            //分享微信
             this.cjState="1117";
             return false;
        }
        //判断是否需要重新再玩
        if(isreplay==='replay'){
            /*vrComponents.fukuangData.gameSocre=0;
            vrComponents.getProgress=0;
            $(".gameProgressNow").css("width","0%");
             if(vrComponents.isWxapp=='0'){
               this.gotoBack();
            }
            window.location.reload();*/
            vrComponents.iframeData.state="replayGame";
        }
       },
       shareWb(){
              //将默认的iframe分享页弹出
              vrComponents.iframeData.isshow=true;
              /*let title="参与冷酸灵寻宝行动互动游戏，让您收获惊喜礼包",
                  url=window.location.href,
                  picurl="http://www.vweb365.com/h5/case/20200521dengkang_v7/static/img/share_wb_img.jpg";
              var sharesinastring = 'http://v.t.sina.com.cn/share/share.php?title=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url) + '&content=utf-8&sourceUrl=' + encodeURIComponent(url) + '&pic=' + encodeURIComponent(picurl);
              window.open(sharesinastring, 'newwindow', 'height=400,width=400,top=100,left=100');*/
       },
       gotoBack(){
             this.cjState="1111";
             vrComponents.cjgamedata.isshow=false;
             return false;
       },
       submitFunc(){
            if(this.uname==''){alert("请输入姓名");return false;}
            if(this.uname.length<2){alert("请认真填写");return false;}
            if(this.uphone==''){alert("请输入您的联系电话");return false;}
            if(this.uaddr==''){alert("请输入您的收货地址");return false;}
            let RegPhone=/^1[0-9]{10}$/;
            if(!RegPhone.test(this.uphone)){alert("请正确输入电话号码");return;}
            let that=this;
            let param = new URLSearchParams();
            param.append('uParameter', 'geted_Info_send');
            param.append('jpid', this.submitId);
            param.append('uname', this.uname);
            param.append('uphone', this.uphone);
            param.append('uaddr', this.uaddr);
            axios({
                url: 'http://www.vweb365.com/h5/case/20200521dengkang_v7/',
                method: 'POST',
                responseType: 'json', // 默认的
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                  },
                data: param
            }).then(function (response) {
                console.log(response.data);
                let resData=response.data;
                if(resData.msg==='1'){
                    //完成提交
                    that.cjState="1119";
                    //更新奖项
                    that.submitState=1;
                }else if(resData.msg==='3'){
                     alert("您填写的手机号已被占用");
                     return false;
                }else{
                    alert("操作失败，请重新参与");
                   // window.location.reload();
                    return false;
                }
            }).catch(function (error) {
                    console.log(error);
                    alert("操作失败，请重新参与");
                   // window.location.reload();
                    return false;
            });
       }
    }
  }
</script>


<style type="text/css">
.cjloadingBox{    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;}
.cjloading_ani1{       width: 1.25rem!important;
    /* height: 1.36rem; */
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;}
.cjloading_ani2{width: 2.97rem!important;    margin-top: 0.7rem;}
.game_over{       width: 6.88rem;
    height: 9rem;}
.btn_cj{       width: 4.44rem;
    height: 0.85rem;
    position: absolute;
    bottom: -2rem;}

  .cjtoppbox,.loadingWrap{background: url(../assets/images/page1_bj.jpg); }
.sharetips{        position: absolute;
    top: 0.7rem;
    right: 0.5rem;
    width: 5.44rem;
    animation-duration: 1.8s;-webkit-animation-duration: 1.8s;
 }
.submitInside{     width: 80%;
    height: 7rem;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 3.7rem; }

  .loadingWrap{ width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center;   position: fixed; z-index: 9999; top:0; left:0;   align-items: center;}
  .imagesWrap img{ width: 100%; }
  .loadingWrap p{ font-size: 0.28rem;
    width: 100%;
    text-align: center;
    display: flex;
    height: 0.5rem;
    justify-content: center;
    left: 0;
    line-height: 1.2rem;
    position: absolute; }
  

.jptext{       font-size: 0.29rem;
    line-height: 0.4rem;
    height: 0.8rem;
    text-align: center;
    margin-bottom: 0.35rem;
    color: #fff;}
.jpimg{    width: 2.8rem;
    position: absolute;
    top: 2.25rem;}
.cj_submit_bj{ width: 6.09rem;height: 9.75rem; }
.btn_submit{  width: 4.44rem;
    background-color: transparent;
    height: 0.85rem;
    border-radius: 0;
    text-align: center;
    font-size: 0.36rem;
    line-height: 0.7rem;
    color: #fff;
    position: absolute;
    bottom: 0.55rem;}
.textfroms{           background-color: #d1eaff;
    border: none;
    /* border: none; */
    width: 75%;
    height: 0.7rem;
    border-radius: 0.08rem;
    font-size: 0.32rem;
    color: #333;
    outline-style: none;
    margin-bottom: 0.3rem;
    font-family: '\5FAE\8F6F\96C5\9ED1';
    text-align: center;}
/* .cjtoppbox{flex-wrap: wrap;     flex-direction: column; display: flex;} */
.cjFailedBox,.cjSuccessBox,.shareTipsBox,.beginCjBox{ 
    flex-wrap: wrap;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    display:flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    height: 100vh;
    top: 0px;
}
.cjSuccessBox{ 
    flex-direction: column;
    display:flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    height: 100vh;
    top: 0px;
}
.failedboxes,.successboxes,.submitOkBoxes,.beginboxes{    width: 100%;
    height: 6rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;}
    .failedboxes{    margin-top: 2rem;}
.successboxes{   height: 10rem;
    margin-top: 0.4rem;}
.sharebj{  width: 7.47rem; margin-bottom: 0.5rem}
.btn_cj_close{ width: 1.07rem;
    bottom: -16px;
    position: absolute;
    z-index: 9;}
.btn_share{     width: 4.44rem;
    position: absolute;
    z-index: 9;}
    .beginboxes{    margin-top: 2.5rem;}


.spinner {
    margin: 0 auto;
    width: 1.85rem;
    height: 1.85rem;
    position: relative;
}
 
.container1 > div, .container2 > div, .container3 > div {
    width: 0.25rem;
    height: 0.25rem;
    background-color: #fff;
    border-radius: 100%;
    position: absolute;
    -webkit-animation: bouncedelay 1.2s infinite ease-in-out;
    animation: bouncedelay 1.2s infinite ease-in-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
 
.spinner .spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
}
 
.container2 {
  -webkit-transform: rotateZ(45deg);
  transform: rotateZ(45deg);
}
 
.container3 {
  -webkit-transform: rotateZ(90deg);
  transform: rotateZ(90deg);
}
 
.circle1 { top: 0; left: 0; }
.circle2 { top: 0; right: 0; }
.circle3 { right: 0; bottom: 0; }
.circle4 { left: 0; bottom: 0; }
 
.container2 .circle1 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
 
.container3 .circle1 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}
 
.container1 .circle2 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
 
.container2 .circle2 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
 
.container3 .circle2 {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}
 
.container1 .circle3 {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}
 
.container2 .circle3 {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
 
.container3 .circle3 {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}
 
.container1 .circle4 {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}
 
.container2 .circle4 {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}
 
.container3 .circle4 {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}
 
@-webkit-keyframes bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0.0) }
  40% { -webkit-transform: scale(1.0) }
}
 
@keyframes bouncedelay {
  0%, 80%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 40% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}

</style>


// WEBPACK FOOTER //
// src/components/gamecjBox.vue